export default {"src":"/_next/static/image/public/images/flags/flag_39.4178a5a13cce2def3cd365ca531a6052.svg","height":16,"width":24};